<template>
  <div class="header">
    <div class="heade_nac">
      <div @click="jumpto"><img src="../assets/images/nav_logo_blue.svg"></div>
      <div class="Nav">
        <div   @click="jump('index')">首页</div>
        <div :class="{birder:index==1,divs:index!=1,divs2:index==1}" @click="jumpIndex('/?index=1',1)">赛事直播 </div>

        <div  :class="{birder:index==3}" @click="jump('/a/saigerui/index.html',3)"  >行业观点</div>
        <!-- <div :class="{birder:index==6}" @click="jumpIndex('footsearch',6)">足环查询 </div> -->
        <div :class="{birder:index==7}" @click="jumpIndex('/product?index=2',7)">产品报价 </div>

        <div :class="{birder:index==2}" @click="jumpIndex('/contect?index=2',2)" >关于赛格锐</div>

      </div>

    </div>
  </div>

</template>
<script>
import store from '@/store'
export default {
  data () {
    return {
      index_dev: 0,
      isFixed: false,
      offsetTop: 81
    }
  },
  computed: {
    index () {
      return store.getters.index
    }
  },
  created () {
    console.log(store.getters.index)

    this.index_dev = this.getQueryVariable('index')
    store.commit('changindex', this.index_dev)
    window.addEventListener('scroll', this.initHeight)
  },
  methods: {
    jumpIndex (path) {
       const domain = process.env.NODE_ENV === 'production'
          ? 'https://live.sigoran.com/#'
          : process.env.NODE_ENV === 'test'
          ?'https://test-live.sigoran.com/#'
          :"https://test-live.sigoran.com/#"
        window.open(`${domain}${path}`, '_blank')
    },
jump (path, index) {
  let that = this
  if (index === 3) {
    // 外部链接，新开标签页
    window.open(this.$store.getters.baseurl + path, '_blank')
  } else if (path === 'index') {
    // 外部链接，新开标签页
    window.open(this.$store.getters.baseurl, '_blank')
  } else {
    // 内部路由，新开标签页
    // 使用router.resolve解析路由，得到路由的完整路径
    const route = this.$router.resolve({
      path: path,
    })
    window.open(route.href, '_blank')
    // 原页面不执行commit，因为跳转到了新标签页，原页面状态不变
    // store.commit('changindex', index) // 注释掉这行，因为原页面不需要改变状态
    // that.index_dev = index // 同样注释掉，原页面不需要改变
  }
},
    getQueryVariable (variable) {
      var query = window.location.hash
      var hash = query.slice(query.indexOf('?') + 1).split('&')

      for (var i = 0; i < hash.length; i++) {
        var pair = hash[i].split('=')
        if (pair[0] === variable) { return pair[1] }
      }
      return (false)
    },
    jumpto () {
      window.location.href = this.$store.getters.baseurl
    },
    initHeight () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.isFixed = scrollTop > this.offsetTop
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style >
  .top_ding{
    position: fixed;
    top:0px;
    z-index: 999;
  }

  .heade_nac{
    cursor: pointer;
    width: 1200px;
    height: 80px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .header {
  background: #ffffff;
    width: 100%;
    border-bottom: 1px  solid  #D8D8D8;
    position: sticky;
    position: -webkit-sticky;
    top:0px;
    z-index: 999;
    cursor: pointer;
  }

  .header img {
    width: 100%;
  }

  .Nav {
    position: relative;
    width: 800px;
    height: 50px;
    display: flex;
    justify-content: space-around;

  }

  .Nav div {
    line-height: 50px;
    font-size: 18px;
    cursor: pointer;
  }
  .divs2::after{
    position: relative;
    top: 6px;
    content: "";
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url("../assets/images/sageran_ic3.svg") no-repeat;
  }

  .divs::after{
    position: relative;
    top: 6px;
    margin-left: 5px;
    content: "";
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url("../assets/images/sageran_ic2.svg") no-repeat;
  }
  .birder{
    color: #2556C4;
    border-bottom: 2px solid #2556C4;
  }
  .dianji{
    width: 200px;height: 30px;

  position: absolute;
    top: 20px;
    right: 160px;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue